import React from 'react';
import { LobsterRopePriceSlider } from '../common/SliderControls/SliderControls';
import type { RegistryComponentProps } from '../../pages/registry/componentRegistry';
import { getRegistryData } from '../../pages/registry/componentRegistry';
import { useFormContextOptional } from '../../contexts/FormContext';

const SLUG = 'rope-price';
const SLUG_DB = 'rope-price-db';

const DEFAULT_ROPE_PRICE = 0.5;

interface RopePriceData {
  updatingParams?: boolean;
  fuelPriceUpdatingParams?: boolean;
  lobsterDisabled?: boolean;
}

export default function RopePrice(props: RegistryComponentProps): React.ReactElement {
  const formContext = useFormContextOptional();
  const data = getRegistryData<RopePriceData>(props);

  const formValue = formContext?.values?.[SLUG] as number | undefined;
  const formDbValue = formContext?.values?.[SLUG_DB] as number | undefined;
  const ropePrice = formValue ?? DEFAULT_ROPE_PRICE;
  const dbRopePrice = formDbValue ?? ropePrice;
  const updatingParams =
    data.updatingParams ?? data.fuelPriceUpdatingParams ?? data.lobsterDisabled ?? false;

  const handleRopePriceChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = parseFloat(e.target.value);
      formContext?.setValue(SLUG, value);
    },
    [formContext]
  );

  return (
    <LobsterRopePriceSlider
      ropePrice={ropePrice}
      dbRopePrice={dbRopePrice}
      handleRopePriceChange={handleRopePriceChange}
      updatingParams={updatingParams}
    />
  );
}
